// extracted by mini-css-extract-plugin
var _1 = "ColorCell_cell__X-OCC";
var _2 = "ColorCell_wrapper__+TRAC";
export { _1 as "cell", _2 as "wrapper" }
